import { Input } from '@qodo/design-system';
import { spawn } from 'utils/translations';
import { CONNECTION_METHODS } from '../consts';
import { PatMethodSectionProps } from '../types';

export const PatMethodSection = ({
  isSelected,
  phase,
  setPhase,
  patValue,
  orgUrl,
  error,
  onPatInputChange,
  onOrgUrlInputChange,
}: PatMethodSectionProps) => {
  const spawnStep = spawn('dialogs.azure-installation.steps.installation-type');
  const spawnPat = spawn('dialogs.azure-installation.steps.pat-connect');
  const isOrgPhase = phase === CONNECTION_METHODS.ORG;

  if (!isSelected) {
    return <></>;
  }

  const onInputChange = (value: string) => {
    if (isOrgPhase) {
      onOrgUrlInputChange('');
      setPhase(CONNECTION_METHODS.PAT);
    }

    onPatInputChange(value);
  };

  return (
    <div className="flex flex-col gap-4 pl-1">
      <div className="flex flex-col gap-2">
        <label
          htmlFor="pat-input"
          className="text-xs uppercase font-mono text-text-general-neutral-mid"
        >
          {spawnPat('pat-label')}*
        </label>
        <Input
          id="pat-input"
          type="password"
          value={patValue}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onInputChange(e.target.value)
          }
          placeholder={spawnStep('pat-placeholder')}
          autoComplete="off"
          className="dark:bg-fill-input-neutral-idle border-border-input-neutral-idle p-2"
        />
      </div>
      {isOrgPhase && (
        <div className="flex flex-col">
          <div className="flex flex-col gap-4">
            <div className="text-muted-foreground flex">
              <span className="text-sm text-text-bg-neutral-mild font-normal">
                {spawnStep('org-required-notice')}
              </span>
            </div>
            <div className="flex flex-col gap-2">
              <label
                htmlFor="org-url-input"
                className="text-xs uppercase font-mono text-text-general-neutral-mid"
              >
                {spawnStep('org-url-label')}
              </label>
              <Input
                id="org-url-input"
                type="text"
                value={orgUrl}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  onOrgUrlInputChange(e.target.value)
                }
                placeholder={spawnStep('org-url-placeholder')}
                className="dark:bg-fill-input-neutral-idle border-border-input-neutral-idle p-2"
              />
            </div>
          </div>
        </div>
      )}
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
};
